"use client";

import Link from "next/link";
import PropertyListingCard from "@/components/bnp-ui/listing-card/PropertyListingCard";
import { buildPropertyDetailPath } from "@/lib/seo/property-urls";
import type { Property } from "@/types/property";

interface Props {
  property: Property;
}

export default function UrlOptimizedListingCardContainer({
  property,
}: Props) {
  return (
    <Link href={buildPropertyDetailPath(property)} className="block h-full">
      <PropertyListingCard property={property} />
    </Link>
  );
}
